import { configureStore } from "@reduxjs/toolkit";
import {
  getProductsUnderReOrderLevelApi,
  productsApi,
} from "./api/productsApi";
import { supplierApi } from "./api/supplierApi";
import { consumerApi } from "./api/consumerApi";
import {
  getLastGenIdsApi,
  GetStockMovementReportApi,
  movementApi,
  productOrderApi,
} from "./api/movementApi";
import {
  ModifyRequestOrderApi,
  ModifyRequestOrderDetailsApi,
  getAllRequestedApi,
  getLastGenIdApi,
  getRequestedProductByCurrentMonthApi,
  getRequestedProductsReportApi,
  orderProductApi,
  requestOrderApi,
} from "./api/orderProductApi";
import { notificationsApi } from "./api/notificationApi";
import {
  UserRolesApi,
  saveUserRoleApi,
  signInCheckUserApi,
  signInUserApi,
  signUpUserApi,
  updateUserRoleApi,
  userDropDownApi,
} from "./api/userAuthApi";
import { businessApi } from "./api/businessApi";
import {
  RequestedMaterialsApi,
  getLastRequestGenIdApi,
} from "./api/RequestedMaterialsApi";
import { categoryApi } from "./api/categoryApi";
import { UnitsApi } from "./api/UnitsApi";
import { CreditPurchaseApi } from "./api/creditPurchaseApi";

export const store = configureStore({
  reducer: {
    [productsApi.reducerPath]: productsApi.reducer,
    [supplierApi.reducerPath]: supplierApi.reducer,
    [consumerApi.reducerPath]: consumerApi.reducer,
    [movementApi.reducerPath]: movementApi.reducer,
    [productOrderApi.reducerPath]: productOrderApi.reducer,
    [orderProductApi.reducerPath]: orderProductApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [requestOrderApi.reducerPath]: requestOrderApi.reducer,
    [signInUserApi.reducerPath]: signInUserApi.reducer,
    [signUpUserApi.reducerPath]: signUpUserApi.reducer,
    [businessApi.reducerPath]: businessApi.reducer,
    [getProductsUnderReOrderLevelApi.reducerPath]:
      getProductsUnderReOrderLevelApi.reducer,
    [getRequestedProductByCurrentMonthApi.reducerPath]:
      getRequestedProductByCurrentMonthApi.reducer,
    [getLastGenIdApi.reducerPath]: getLastGenIdApi.reducer,
    [getAllRequestedApi.reducerPath]: getAllRequestedApi.reducer,
    [getLastGenIdsApi.reducerPath]: getLastGenIdsApi.reducer,
    [signInCheckUserApi.reducerPath]: signInCheckUserApi.reducer,
    [userDropDownApi.reducerPath]: userDropDownApi.reducer,
    [UserRolesApi.reducerPath]: UserRolesApi.reducer,
    [updateUserRoleApi.reducerPath]: updateUserRoleApi.reducer,
    [saveUserRoleApi.reducerPath]: saveUserRoleApi.reducer,
    [ModifyRequestOrderApi.reducerPath]: ModifyRequestOrderApi.reducer,
    [ModifyRequestOrderDetailsApi.reducerPath]:
      ModifyRequestOrderDetailsApi.reducer,
    [RequestedMaterialsApi.reducerPath]: RequestedMaterialsApi.reducer,
    [getLastRequestGenIdApi.reducerPath]: getLastRequestGenIdApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [UnitsApi.reducerPath]: UnitsApi.reducer,
    [CreditPurchaseApi.reducerPath]: CreditPurchaseApi.reducer,
    [getRequestedProductsReportApi.reducerPath]:
      getRequestedProductsReportApi.reducer,
    [GetStockMovementReportApi.reducerPath]: GetStockMovementReportApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      productsApi.middleware,
      supplierApi.middleware,
      consumerApi.middleware,
      movementApi.middleware,
      productOrderApi.middleware,
      orderProductApi.middleware, // request
      notificationsApi.middleware,
      requestOrderApi.middleware,
      signInUserApi.middleware,
      signUpUserApi.middleware,
      businessApi.middleware,
      getProductsUnderReOrderLevelApi.middleware,
      getRequestedProductByCurrentMonthApi.middleware,
      getLastGenIdApi.middleware,
      getAllRequestedApi.middleware,
      getLastGenIdsApi.middleware,
      signInCheckUserApi.middleware,
      userDropDownApi.middleware,
      UserRolesApi.middleware,
      updateUserRoleApi.middleware,
      saveUserRoleApi.middleware,
      ModifyRequestOrderApi.middleware,
      ModifyRequestOrderDetailsApi.middleware,
      RequestedMaterialsApi.middleware,
      getLastRequestGenIdApi.middleware,
      categoryApi.middleware,
      UnitsApi.middleware,
      CreditPurchaseApi.middleware,
      getRequestedProductsReportApi.middleware,
      GetStockMovementReportApi.middleware,
    ]),
});
